import { ConditionRegistryItem } from '../../ConditionRegistryItem';
import { ConditionRegistryCategory } from '../../ConditionRegistryCategory';
export class ConditionRegistryImage extends ConditionRegistryCategory {
    label = 'Image';
    constructor(parent) {
        super(parent);
        super.init();
    }
    isSvgr = () => new ConditionRegistryItem({
        eval: ({ actor }) => {
            const image = actor;
            if (!image.img)
                return false;
            return image.img.isSvgrComponent;
        }
    });
}
